import { useTranslation } from "react-i18next";
import { GET_MILESTONE_STATUSES } from "../constants";
import styles from "../styles.module.scss";
import {
  IContractDetailsResponseData,
  UserProfile,
} from "../../../../setup/api/services/contract/models";

export const MilestoneStatus = ({
  contract,
  fetchProviders,
  userId,
}: {
  contract: IContractDetailsResponseData;
  fetchProviders: (
    contract: IContractDetailsResponseData
  ) => Partial<UserProfile & { userId?: string }>[];
  userId: string | undefined;
}) => {
  const { t } = useTranslation();
  const milestoneStatuses = GET_MILESTONE_STATUSES(t);
  let userType = "buyer";
  if (
    fetchProviders(contract)?.some((provider) => provider?.userId === userId)
  ) {
    userType = "seller";
  }

  return (
    <div
      className={styles.status_card}
      style={{
        background:
          milestoneStatuses?.[userType]?.[contract?.status]?.backgroundColor,
      }}>
      <div className={styles.status_row}>
        <img
          alt="status"
          width="46px"
          height="46px"
          src={milestoneStatuses?.[userType]?.[contract?.status]?.logo}
        />
        <div className={styles.status_text_wrapper}>
          <p className={"subtitle2"} style={{ fontWeight: 600 }}>
            {milestoneStatuses?.[userType]?.[contract?.status]?.title}
          </p>
          <p className={"hint2"} style={{ fontSize: "14px" }}>
            {milestoneStatuses?.[userType]?.[contract?.status]?.subTitle}
          </p>
        </div>
      </div>
    </div>
  );
};
